// PaginationControls component extracted from OfferPageBuilderSimple.js lines 1854-1955
import React from 'react';
import { Box, Typography, IconButton, Divider } from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  CallSplit as CallSplitIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import { useOfferBuilder } from '../OfferBuilderContext';

const PaginationControls = () => {
  const {
    paginationEnabled,
    currentPageIndex,
    pages,
    setCurrentPageIndex,
    goToPreviousPage,
    goToNextPage,
    isEditingMode,
    mergeWithNextPage,
    deletePage,
  } = useOfferBuilder();

  if (!paginationEnabled) return null;

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      p: 0.5,
      px: 1,
      backgroundColor: '#ffffff',
      borderRadius: 1,
      border: '1px solid #e0e0e0',
      boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
      mb: 0.5
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '0.8rem', color: 'primary.main', whiteSpace: 'nowrap' }}>
          P. {currentPageIndex + 1}/{pages.length}
        </Typography>

        <Box sx={{ display: 'flex', gap: 0.5 }}>
          {pages.map((_, index) => (
            <Box
              key={index}
              sx={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                backgroundColor: index === currentPageIndex ? 'primary.main' : '#ccc',
                cursor: 'pointer'
              }}
              onClick={() => setCurrentPageIndex(index)}
            />
          ))}
        </Box>
      </Box>

      <Divider orientation="vertical" flexItem sx={{ mx: 0.2, height: 16, alignSelf: 'center' }} />

      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <IconButton
          size="small"
          disabled={currentPageIndex === 0}
          onClick={goToPreviousPage}
          sx={{
            border: '1px solid #e0e0e0',
            p: 0.2,
            borderRadius: 1,
            width: 26,
            height: 26
          }}
          title="Previous Page"
        >
          <ArrowBackIcon sx={{ fontSize: '0.9rem' }} />
        </IconButton>

        <IconButton
          size="small"
          disabled={currentPageIndex === pages.length - 1}
          onClick={goToNextPage}
          sx={{
            border: '1px solid #e0e0e0',
            p: 0.2,
            borderRadius: 1,
            width: 26,
            height: 26
          }}
          title="Next Page"
        >
          <ArrowForwardIcon sx={{ fontSize: '0.9rem' }} />
        </IconButton>
      </Box>

      {isEditingMode && pages.length > 1 && (
        <>
          <Divider orientation="vertical" flexItem sx={{ mx: 0.5, height: 20, alignSelf: 'center' }} />
          <Box sx={{ display: 'flex', gap: 0.5 }}>
            {currentPageIndex < pages.length - 1 && (
              <IconButton
                size="small"
                onClick={mergeWithNextPage}
                title="Merge with Next Page"
                sx={{ color: 'primary.main', p: 0.2 }}
              >
                <CallSplitIcon fontSize="small" />
              </IconButton>
            )}
            <IconButton
              size="small"
              onClick={() => deletePage(currentPageIndex)}
              title="Delete Current Page"
              sx={{ color: 'error.main', p: 0.2 }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        </>
      )}
    </Box>
  );
};

export default PaginationControls;
